/**
 * BE BOLD : Path A: Strengthen and Build
 * Month 1: Foundation (Days 1-30)
 *
 * Squeeze 30-50%, hold 3-5s. Finding the floor.
 *
 * All sessions verified at 300s +/-20s (5 minutes)
 * Generated: 2026-04-13 02:14
 *
 * bebold.au | Paula Tomazetti | 16+ years of study
 * All content is 100% Be Bold.
 */

export const exercises = {

  belly_breath_drop: {
    id: 'belly_breath_drop',
    name: 'Belly Breath Drop',
    name_pt: 'Respiro da Barriga',
    sub: 'The floor drops on the inhale. Stay soft on the exhale.',
    sub_pt: 'O assoalho cai na inspiração. Fique macia na expiração.',
    why: 'Slow belly breathing lets the pelvic floor move down naturally on the inhale, building awareness of its relaxed, resting state.',
    why_pt: 'A respiração lenta na barriga deixa o assoalho pélvico descer naturalmente na inspiração, construindo consciência do seu estado relaxado e de repouso.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back with your knees bent and feet flat. Place one hand on your lower belly.

Inhale slowly through your nose for 4 counts. Feel your belly rise under your hand. Your pelvic floor drops gently as your belly expands. You do not push it. It falls on its own.

Exhale through your mouth for 6 counts. Stay soft. Nothing tightens on the exhale. The floor stays dropped.

If you feel nothing at first, that is your starting point.

Picture it: your pelvic floor is a hammock between two trees. Each inhale, the hammock sinks wider. Each exhale, it stays low.`,
    inst_pt: `Deite de costas com os joelhos dobrados e pés apoiados. Coloque uma mão na barriga baixa.

Inspire lentamente pelo nariz por 4 tempos. Sinta a barriga subir sob sua mão. Seu assoalho pélvico desce suavemente conforme a barriga expande. Você não empurra. Ele cai sozinho.

Expire pela boca por 6 tempos. Fique macia. Nada contrai na expiração. O assoalho continua solto.

Se não sentir nada no início, esse é seu ponto de partida.

Visualize: seu assoalho pélvico é uma rede entre duas árvores. Cada inspiração, a rede afunda e alarga. Cada expiração, ela fica baixa.`,
    breathe: 'Inhale 4 counts to drop. Exhale 6 counts to stay soft.',
    breathe_pt: 'Inspire 4 tempos para soltar. Expire 6 tempos para ficar macia.',
    timerCue: `Inhale.
Drop.
Exhale.
Stay soft.`,
    timerCue_pt: `Inspire.
Solte.
Expire.
Fique macia.`,
    feel: 'A subtle widening and heaviness in the pelvic bowl on every inhale. Nothing tense. Nothing forced.',
    feel_pt: 'Uma sutil abertura e peso na pelve a cada inspiração. Nada tenso. Nada forçado.',
    avoid: 'Do not push the floor down. Do not bear down. Do not tighten on the exhale.',
    avoid_pt: 'Não empurre o assoalho para baixo. Não faça força. Não contraia na expiração.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  child_pose_release: {
    id: 'child_pose_release',
    pose: 'child-pose',
    name: 'Child Pose Release',
    name_pt: 'Soltura na Posição Criança',
    sub: 'The deepest passive stretch for a tight floor.',
    sub_pt: 'O alongamento passivo mais profundo para um assoalho tenso.',
    why: 'A supported forward-folded position with slow breathing gives the pelvic floor room to lengthen and settle.',
    why_pt: 'Uma posição dobrada para frente e apoiada, com respiração lenta, dá ao assoalho pélvico espaço para se alongar e relaxar.',
    level: 'Release',
    zone: 'Full floor 0-6cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Kneel on a soft surface. Bring your knees wide apart. Sit back onto your heels. Stretch your arms forward on the floor.

Let your forehead rest on the floor or on a pillow. Let your belly hang between your thighs.

Inhale for 4 counts. Feel your belly expand toward the floor. Your pelvic floor lengthens between your sit bones.

Exhale for 6 counts. Let everything drop heavier. Gravity pulls your belly down and your floor opens.

Stay here for the full time. No effort. No movement. Just breathing into the stretch.

Picture it: a cat stretching after a nap. Front paws forward, hips back, belly dropped. Total surrender. Or draping a wet towel over a round surface. The towel has no shape of its own. It just falls over whatever is underneath.`,
    inst_pt: `Ajoelhe numa superfície macia. Abra os joelhos bem. Sente nos calcanhares. Estique os braços para frente no chão.

Deixe a testa descansar no chão ou num travesseiro. Deixe a barriga pendurar entre as coxas.

Inspire por 4 tempos. Sinta a barriga expandir em direção ao chão. Seu assoalho pélvico se alonga entre os ísquios.

Expire por 6 tempos. Deixe tudo cair mais pesado. A gravidade puxa a barriga para baixo e seu assoalho abre.

Fique aqui pelo tempo todo. Sem esforço. Sem movimento. Apenas respirando no alongamento.

Visualize: um gato se espreguiçando depois da soneca. Patas dianteiras para frente, quadril para trás, barriga caída. Rendição total. Ou cobrindo uma superfície arredondada com uma toalha molhada. A toalha não tem forma própria. Apenas cai.`,
    breathe: 'Inhale to lengthen. Exhale to surrender.',
    breathe_pt: 'Inspire para alongar. Expire para se render.',
    timerCue: `Inhale.
Lengthen.
Exhale.
Surrender.`,
    timerCue_pt: `Inspire.
Alongue.
Expire.
Rendição.`,
    feel: 'Deep opening across the entire pelvic floor. The belly hangs. The floor stretches.',
    feel_pt: 'Abertura profunda em todo o assoalho pélvico. A barriga pendura. O assoalho se alonga.',
    avoid: 'Do not bear down. If knees hurt, cushion between calves and thighs.',
    avoid_pt: 'Não faça força. Se joelhos doem, almofada entre panturrilhas e coxas.',
    type: 'timed',
    sets: 1,
    hold: 150,
    rest: 0,
  },

  gentle_push_reset: {
    id: 'gentle_push_reset',
    name: 'Gentle Push Reset',
    name_pt: 'Reset Suave',
    sub: 'After every squeeze set, 15 pushes confirm rest.',
    sub_pt: 'Após cada série de aperto, 15 empurrões confirmam repouso.',
    why: 'A light downward release after squeezing helps confirm the pelvic floor has returned to a relaxed resting state between efforts.',
    why_pt: 'Uma soltura leve para baixo após o aperto ajuda a confirmar que o assoalho pélvico voltou a um estado de repouso relaxado entre os esforços.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8A6A7A',
    movement: 'push',
    inst: `After your squeeze set, exhale and gently push the pelvic floor downward. 15% effort. Hold 4 seconds. Release. Repeat 15 times. This confirms the floor returned to true rest.

Picture it: pressing reset on a stopwatch. Each click brings you back to zero.`,
    inst_pt: `Após sua série de aperto, expire e empurre suavemente o assoalho para baixo. 15% esforço. Segure 4 segundos. Solte. Repita 15 vezes. Isso confirma repouso real.

Visualize: apertando reset num cronômetro. Cada clique te traz de volta ao zero.`,
    breathe: 'Exhale to push. Inhale to release.',
    breathe_pt: 'Expire para empurrar. Inspire para soltar.',
    timerCue: `Exhale.
Push.
Release.`,
    timerCue_pt: `Expire.
Empurre.
Solte.`,
    feel: 'Gentle downward opening after each squeeze set.',
    feel_pt: 'Abertura suave para baixo após cada série de aperto.',
    avoid: 'Do not skip after squeeze exercises. Do not strain.',
    avoid_pt: 'Não pule após exercícios de aperto. Não force.',
    type: 'hold',
    sets: 15,
    hold: 4,
    relax: 6,
    rest: 0,
  },

  hip_rock_release: {
    id: 'hip_rock_release',
    name: 'Hip Rock Release',
    name_pt: 'Balanço do Quadril',
    sub: 'Movement teaches the floor to let go.',
    sub_pt: 'Movimento ensina o assoalho a soltar.',
    why: 'Gentle pelvic rocking pairs movement with breath to help the pelvic floor alternate between opening and softening.',
    why_pt: 'O balanço suave da pelve une movimento e respiração para ajudar o assoalho pélvico a alternar entre abrir e amolecer.',
    level: 'Release',
    zone: 'Full floor 0-3cm',
    color: '#7A5A6A',
    movement: 'release',
    inst: `Lie on your back, knees bent, feet flat.

Slowly tilt your pelvis forward: your low back arches slightly away from the floor. Feel your pelvic floor gently stretch open.

Slowly tilt your pelvis back: your low back presses into the floor. Feel your pelvic floor gently compress.

Rock between these two positions slowly. Forward tilt opens the floor. Back tilt closes it lightly. Each rock takes about 4 seconds forward, 4 seconds back.

During the forward tilt, actively breathe into the stretch. Let the floor open.

Picture it: your pelvis is a bowl of water. Tilt forward, water tips toward your belly button. Tilt back, water tips toward your spine. Smooth, no spilling. Or a rocking chair in slow motion, the whole thing moving as one piece.`,
    inst_pt: `Deite de costas, joelhos dobrados, pés apoiados.

Lentamente incline a pelve para frente: a lombar se afasta levemente do chão. Sinta o assoalho pélvico se alongar suavemente.

Lentamente incline a pelve para trás: a lombar pressiona o chão. Sinta o assoalho pélvico comprimir levemente.

Balance entre as duas posições devagar. Inclinação frontal abre o assoalho. Inclinação posterior fecha levemente. Cada balanço leva cerca de 4 segundos para frente, 4 para trás.

Durante a inclinação frontal, respire ativamente no alongamento. Deixe o assoalho abrir.

Visualize: sua pelve é uma tigela de água. Incline para frente, água vai ao umbigo. Incline para trás, água vai à coluna. Suave, sem derramar. Ou cadeira de balanço em câmera lenta, tudo se movendo como uma peça.`,
    breathe: 'Inhale as you tilt forward (open). Exhale as you tilt back (neutral).',
    breathe_pt: 'Inspire ao inclinar para frente (abrir). Expire ao inclinar para trás (neutro).',
    timerCue: `Forward.
Open.
Back.
Neutral.`,
    timerCue_pt: `Frente.
Abra.
Trás.
Neutro.`,
    feel: 'A gentle rocking that alternates between stretching and softening. Like a wave inside your pelvis.',
    feel_pt: 'Um balanço suave que alterna entre alongar e amolecer. Como uma onda dentro da pelve.',
    avoid: 'Do not rush. Do not lift your hips off the ground. Do not bear down.',
    avoid_pt: 'Não apresse. Não levante o quadril do chão. Não faça força.',
    type: 'alt',
    sets: 19,
    hold: 4,
    relax: 4,
    rest: 0,
    altA: 'Forward',
    altA_pt: 'Frente',
    altB: 'Back',
    altB_pt: 'Trás',
  },

  squeeze_3s: {
    id: 'squeeze_3s',
    name: 'Foundation Squeeze 3s',
    name_pt: 'Aperto Base 3s',
    sub: 'CLOSE and SQUEEZE at 40%. Hold 3 seconds. Release fully.',
    sub_pt: 'FECHE e APERTE em 40%. Segure 3 segundos. Solte totalmente.',
    why: 'A short squeeze at gentle effort helps you find and connect with the pelvic floor, with a full release so the muscle learns to rest as well as lift.',
    why_pt: 'Um aperto curto com esforço suave ajuda a encontrar e se conectar com o assoalho pélvico, com uma soltura completa para o músculo aprender a descansar tanto quanto a elevar.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie on your back, knees bent.

CLOSE the pelvic walls inward and SQUEEZE upward at 40% effort. Hold for 3 seconds. Breathe normally while holding.

Release completely for 5 seconds. Full drop. The release matters as much as the lift.

If you cannot feel the squeeze at all, try stopping an imaginary urine stream. That is the muscle group. Once found, never use the stop-urine method as a regular exercise.

Picture it: picking up a grape without crushing it. Hold for 3 seconds. Set it down gently. Or closing a zipper halfway, holding, then unzipping completely.`,
    inst_pt: `Deite de costas, joelhos dobrados.

FECHE as paredes pélvicas para dentro e APERTE para cima com 40% esforço. Segure por 3 segundos. Respire normalmente.

Solte completamente por 5 segundos. Queda total. A soltura importa tanto quanto o aperto.

Se não sentir o aperto, tente parar um jato imaginário de urina. Esse é o grupo muscular. Uma vez encontrado, nunca use o método de parar urina como exercício.

Visualize: pegando uma uva sem esmagar. Segure 3 segundos. Coloque suavemente. Ou fechando zíper até a metade, segurando, depois abrindo completamente.`,
    breathe: 'Exhale to CLOSE and SQUEEZE. Inhale to release.',
    breathe_pt: 'Expire para FECHAR e APERTAR. Inspire para soltar.',
    timerCue: `Squeeze.
Hold 3.
Release.`,
    timerCue_pt: `Aperte.
Segure 3.
Solte.`,
    feel: 'A gentle inward and upward movement. Not in the buttocks. Not in the thighs.',
    feel_pt: 'Um movimento suave para dentro e para cima. Não nos glúteos. Não nas coxas.',
    avoid: 'Do not hold breath. Do not bear down. Do not clench buttocks or inner thighs.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não contraia glúteos ou coxas internas.',
    type: 'hold',
    sets: 19,
    hold: 3,
    relax: 5,
    rest: 0,
  },

  squeeze_5s: {
    id: 'squeeze_5s',
    name: 'Foundation Squeeze 5s',
    name_pt: 'Aperto Base 5s',
    sub: 'CLOSE and SQUEEZE at 50%. Hold 5 seconds.',
    sub_pt: 'FECHE e APERTE em 50%. Segure 5 segundos.',
    why: 'A longer, steady hold helps you build control and stamina in the pelvic floor, and the equal release teaches it to let go fully afterwards.',
    why_pt: 'Uma sustentação mais longa e firme ajuda a construir controle e resistência no assoalho pélvico, e a soltura igual ensina a soltar por completo depois.',
    level: 'Foundation',
    zone: 'Full floor 0-3cm',
    color: '#8B4A5A',
    movement: 'squeeze',
    inst: `Lie down or sit. CLOSE and SQUEEZE at 50% effort. Hold 5 seconds. Breathe normally. Release completely for 5 seconds.

The muscle should hold steady for the full 5 seconds. If it fades at 3 seconds, that IS your current limit. Build from there.

Picture it: holding a glass of water steady for 5 seconds, then setting it down. Controlled up and controlled down.`,
    inst_pt: `Deite ou sente. FECHE e APERTE com 50% esforço. Segure 5 segundos. Respire normal. Solte completamente por 5 segundos.

O músculo deve se manter firme por 5 segundos. Se enfraquecer em 3 segundos, esse É seu limite atual. Construa a partir daí.

Visualize: segurando copo d'água firme por 5 segundos, depois colocando. Controlado sobe e controlado desce.`,
    breathe: 'Exhale to engage. Breathe normally while holding.',
    breathe_pt: 'Expire para engajar. Respire normal enquanto segura.',
    timerCue: `Squeeze.
Hold 5.
Release.`,
    timerCue_pt: `Aperte.
Segure 5.
Solte.`,
    feel: 'Definite lift and a steady hold. The lift stays clear from start to finish.',
    feel_pt: 'Elevação e sustentação definida. A elevação permanece clara do início ao fim.',
    avoid: 'Do not hold breath. Do not bear down. Do not compensate.',
    avoid_pt: 'Não prenda respiração. Não faça força. Não compense.',
    type: 'hold',
    sets: 15,
    hold: 5,
    relax: 5,
    rest: 0,
  },
};

export const days = [
  {
    day: 1, week: 1,
    title: 'Day 1', title_pt: 'Dia 1',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 2, week: 1,
    title: 'Day 2', title_pt: 'Dia 2',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'squeeze_5s', overrides: {"sets": 11} }, // 110s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 3, week: 1,
    title: 'Day 3', title_pt: 'Dia 3',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 4, week: 1,
    title: 'Day 4', title_pt: 'Dia 4',
    exercises: [
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 5, week: 1,
    title: 'Day 5', title_pt: 'Dia 5',
    exercises: [
      { ref: 'squeeze_3s', overrides: {} }, // 152s
      { ref: 'child_pose_release', overrides: {"hold": 148} }, // 148s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 6, week: 1,
    title: 'Day 6', title_pt: 'Dia 6',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 7, week: 1,
    title: 'Day 7', title_pt: 'Dia 7',
    exercises: [
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 13} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 8, week: 2,
    title: 'Day 8', title_pt: 'Dia 8',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 9, week: 2,
    title: 'Day 9', title_pt: 'Dia 9',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 10, week: 2,
    title: 'Day 10', title_pt: 'Dia 10',
    exercises: [
      { ref: 'squeeze_3s', overrides: {} }, // 152s
      { ref: 'hip_rock_release', overrides: {"sets": 18} }, // 144s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 11, week: 2,
    title: 'Day 11', title_pt: 'Dia 11',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 104} }, // 104s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 12, week: 2,
    title: 'Day 12', title_pt: 'Dia 12',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 13, week: 2,
    title: 'Day 13', title_pt: 'Dia 13',
    exercises: [
      { ref: 'hip_rock_release', overrides: {} }, // 152s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 14, week: 2,
    title: 'Day 14', title_pt: 'Dia 14',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 15, week: 3,
    title: 'Day 15', title_pt: 'Dia 15',
    exercises: [
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 16, week: 3,
    title: 'Day 16', title_pt: 'Dia 16',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'squeeze_3s', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 17, week: 3,
    title: 'Day 17', title_pt: 'Dia 17',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'child_pose_release', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 18, week: 3,
    title: 'Day 18', title_pt: 'Dia 18',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 19, week: 3,
    title: 'Day 19', title_pt: 'Dia 19',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 20, week: 3,
    title: 'Day 20', title_pt: 'Dia 20',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 21, week: 3,
    title: 'Day 21', title_pt: 'Dia 21',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_3s', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 22, week: 4,
    title: 'Day 22', title_pt: 'Dia 22',
    exercises: [
      { ref: 'child_pose_release', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 23, week: 4,
    title: 'Day 23', title_pt: 'Dia 23',
    exercises: [
      { ref: 'hip_rock_release', overrides: {} }, // 152s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 24, week: 4,
    title: 'Day 24', title_pt: 'Dia 24',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {} }, // 150s
      { ref: 'squeeze_5s', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 25, week: 4,
    title: 'Day 25', title_pt: 'Dia 25',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'gentle_push_reset', overrides: {} }, // 150s
    ], // Total: 300s = 5.0 min
  },
  {
    day: 26, week: 4,
    title: 'Day 26', title_pt: 'Dia 26',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'squeeze_3s', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 27, week: 4,
    title: 'Day 27', title_pt: 'Dia 27',
    exercises: [
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
      { ref: 'child_pose_release', overrides: {"hold": 100.0} }, // 100.0s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 296.0s = 4.9 min
  },
  {
    day: 28, week: 4,
    title: 'Day 28', title_pt: 'Dia 28',
    exercises: [
      { ref: 'gentle_push_reset', overrides: {"sets": 10} }, // 100s
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'squeeze_3s', overrides: {"sets": 12} }, // 96s
    ], // Total: 296s = 4.9 min
  },
  {
    day: 29, week: 5,
    title: 'Day 29', title_pt: 'Dia 29',
    exercises: [
      { ref: 'squeeze_5s', overrides: {} }, // 150s
      { ref: 'hip_rock_release', overrides: {} }, // 152s
    ], // Total: 302s = 5.0 min
  },
  {
    day: 30, week: 5,
    title: 'Day 30', title_pt: 'Dia 30',
    exercises: [
      { ref: 'belly_breath_drop', overrides: {"sets": 10} }, // 100s
      { ref: 'hip_rock_release', overrides: {"sets": 12} }, // 96s
      { ref: 'squeeze_5s', overrides: {"sets": 10} }, // 100s
    ], // Total: 296s = 4.9 min
  },
];


export const monthMeta = {
  month: 1,
  program: 'weak_pf',
  phase: 'Foundation',
  phase_pt: 'Base',
  days_range: [1, 30],
  session_target_seconds: 300,
};

export function resolveDay(dayNumber) {
  const dayData = days.find(d => d.day === dayNumber);
  if (!dayData) return null;
  return { ...dayData, exercises: dayData.exercises.map(ex => ({ ...exercises[ex.ref], ...ex.overrides })) };
}